import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  alternativeOffersOslCph,
  orderEligibilitiesMockNotEligibleToRefundForSingleBound,
  orderForCityChange,
  orderForCityChangeAcknowledged,
} from '../../../mock/data/index';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const singleBoundDisruptedCityChangeMock: MockMap = {
  retrieveOrder: [createMockData(orderForCityChange, [], [flightDisruptionWarning]), createMockData(orderForCityChangeAcknowledged, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData({
    ...orderEligibilitiesMockNotEligibleToRefundForSingleBound,
    orderId: 'UM8VXN'
  }, [], [orderNotEligibleForRefundWarning])],
  getAlternativeOffers: [createMockData(alternativeOffersOslCph)],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
